import CardHeader from "./CardHeader";
import ViewAllArrowIcon from '../../../../assets/icons/ViewAllArrowIcon.svg?react';
import { COMPANY_MODAL_KEYS } from "../../../../utils/enum";
import { pieViewAllClasses } from '../../../../components/common/dashboardClasses';
import { dashboardTableBodyClasses, upcomingTableClasses, tableHeaderRowClasses } from '../../../../components/common/dashboardTableClasses';

const DashboardSharedTable = ({
  title,
  columns = [],
  data = [],
  icon,
  headerExtra,
  className = '',
  expandIcon= '',
  onRowClick,
  openModal,
  limit,
  hasScroll
}) => {
  const tableData = limit ? data.slice(0, limit) : data;
  return (
    <div className={`${className} flex flex-col`}>
        {title && (
          <CardHeader
            title={title}
            icon={icon}
            rightContent={
              <div className="flex items-center gap-6">
                {headerExtra}
                {expandIcon}
              </div>
            }
          />
        )}

      <div className={hasScroll ? 'max-h-none overflow-y-auto w-full min-h-0' : dashboardTableBodyClasses}>
        <table className={upcomingTableClasses}>
          <thead>
            <tr className={tableHeaderRowClasses}>
              {columns.map((col, index) => (
                <th key={index} className="px-2 py-2 text-left text-base font-bold">
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              tableData.map((row, rowIndex) => (
                <tr key={rowIndex} onClick={() => onRowClick && onRowClick(row)} className={onRowClick ? "cursor-pointer" : "cursor-default"}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex} className="px-2 py-2">
                      {col.render ? col.render(row) : row[col.dataKey]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center py-6 text-body">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {data.length>4&& limit &&<span className={`${pieViewAllClasses} mt-6`} onClick={() => openModal(COMPANY_MODAL_KEYS.RENEWAL_COMPANIES)}>
        View All <ViewAllArrowIcon className="text-primary" />
      </span>}
    </div>
  );
};

export default DashboardSharedTable;